module.exports = __webpack_public_path__ + "img/coin-solid.c69eadc9.svg";